/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
export enum DocumentType {
    REPORT= 0,
    PRESCRIPTION = 1,
    WORKLEAVE = 2,
    CERTIFICATE = 3,
  }
